import { IonItem, IonLabel } from "@ionic/react";
import { PatternFormat } from "react-number-format";

const Phone = ({
	label,
	value,
	onChange,
	displayType = "input",
	labelPosition = "stacked"
}: any) => {
	return displayType === "input" ? (
		<IonItem fill="outline">
			<IonLabel position={labelPosition}>{label}</IonLabel>
			<PatternFormat
				format="+992 #########"
				placeholder="+992 "
				valueIsNumericString={true}
				defaultValue={value}
				value={value}
				onValueChange={values => onChange(values.value)}
				type="tel"
				displayType={displayType}
				style={{
					backgroundColor: "transparent",
					border: "none",
					outline: "none",
					width: "100%"
				}}
			/>
		</IonItem>
	) : (
		<a
			href={`tel:${value}`}
			style={{
				textDecoration: "none"
			}}
		>
			<PatternFormat
				format="+992 #########"
				placeholder="+992 "
				valueIsNumericString={true}
				defaultValue={value}
				type="tel"
				displayType={displayType}
				style={{
					backgroundColor: "transparent",
					border: "none",
					outline: "none",
					width: "100%"
				}}
			/>
		</a>
	);
};

export default Phone;
